import React from "react";
import { Link } from "react-router-dom";

const SCROLL_LINKS = {
    "Online Auctions": "/#how",
    "Silent Auctions": "/#how",
    "Live Events": "/#how",
    "Item Catalog": "/#how",
};

const NONPROFIT_LINKS = [
    { label: "Get started", to: "/signup-org" },
    { label: "Bidder check-in", to: "/login" },
    { label: "Payouts", to: "/login" },
    { label: "Reports", to: "/login" },
];

export default function Footer() {
    return (
        <footer className="border-t border-border bg-primary text-primary-foreground" data-testid="main-footer">
            <div className="px-6 md:px-12 lg:px-24 py-20 grid md:grid-cols-4 gap-12">
                <div>
                    <Link to="/" className="flex items-center gap-3 mb-6" data-testid="footer-logo">
                        <div className="w-9 h-9 bg-accent text-accent-foreground flex items-center justify-center">
                            <span className="font-heading text-xl">cf</span>
                        </div>
                        <span className="font-heading text-xl">CharityFundraiser</span>
                    </Link>
                    <p className="text-primary-foreground/70 text-sm leading-relaxed">
                        The elite fundraising platform built exclusively for non-profits.
                        Raise more. Pay less. Steward better.
                    </p>
                </div>
                <div>
                    <h4 className="label-eyebrow text-primary-foreground/60 mb-4">Platform</h4>
                    <ul className="space-y-3 text-sm">
                        <li><Link to="/features" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-features">All features →</Link></li>
                        <li><Link to="/tour" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-see-it-in-action">See it in action →</Link></li>
                        <li><Link to="/compare" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-compare">Compare vs OneCause, Givebutter</Link></li>
                        <li><Link to="/blog" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-blog">Fundraising News</Link></li>
                        <li><Link to="/find-an-auctioneer" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-find-auctioneer">Find an Auctioneer</Link></li>
                        {Object.entries(SCROLL_LINKS).map(([label, href]) => (
                            <li key={label}>
                                <a href={href} className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid={`footer-platform-${label.toLowerCase().replaceAll(" ", "-")}`}>{label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="label-eyebrow text-primary-foreground/60 mb-4">For non-profits</h4>
                    <ul className="space-y-3 text-sm">
                        {NONPROFIT_LINKS.map(l => (
                            <li key={l.label}>
                                <Link to={l.to} className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid={`footer-np-${l.label.toLowerCase().replaceAll(" ", "-")}`}>{l.label}</Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <h4 className="label-eyebrow text-primary-foreground/60 mb-4">Company</h4>
                    <ul className="space-y-3 text-sm">
                        <li><a href="/#how" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-about">About</a></li>
                        <li><Link to="/contact" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-contact">Contact</Link></li>
                        <li><Link to="/privacy" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-privacy">Privacy</Link></li>
                        <li><Link to="/terms" className="text-primary-foreground/85 hover:text-accent transition-colors" data-testid="footer-terms">Terms</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-primary-foreground/10 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-primary-foreground/50">
                <p>© 2026 CharityFundraiser — Built with care for non-profits.</p>
                <p className="data-num flex items-center gap-3">
                    <span>v 1.0 · powered by good intentions.</span>
                    <Link to="/login" className="text-primary-foreground/15 hover:text-accent transition-colors" title="Staff" data-testid="footer-admin-dot">·</Link>
                </p>
            </div>
        </footer>
    );
}
